import { copy } from "@/shared/utils/string";
import { bannerService } from "@/apps/love/services/banner.service";
import { t } from "@/i18n";
import { cloneDeep, waitForMe } from "@/shared/utils/helpers.js";

export default {
    namespaced: true,
    state: () => ({
        uploads: {
            started: false,
            finished: false,
            items: [],
        },
        imageWidth: "",
    }),
    actions: {
        showDownloadImageModal({ commit }, payload) {
            const modalData = {
                type: "code",
                title: t("love.review_images.image_ready"),
                desc: t("love.review_images.image_ready_desc"),
                code: payload,
                actionBtn: t("love.review_images.image_ready_cta"),
                cancelBtn: t("shared.cancel"),
                callback: () => {
                    copy(payload);
                    window.open(payload, "_blank");
                },
            };
            commit("showModal", modalData, { root: true });
        },
        startUploads({ state, rootState, dispatch }) {
            state.uploads.started = true;

            const hiddenTestimonials = rootState.love.testimonials
                .filter((x) => x.hide == true)
                .map((y) => y.id);
            const hiddenTitle = rootState.love.wall.hideTitle;

            dispatch("uploadItem", {
                index: 0,
                hiddenTestimonials: hiddenTestimonials,
                hiddenTitle: hiddenTitle,
            });
        },
        stopUploads({ state }) {
            state.uploads.started = false;
            state.uploads.finished = true;
            state.imageWidth = "";
        },
        uploadItem({ state, rootState, dispatch }, payload) {
            const index = payload.index;
            const hiddenTestimonials = payload.hiddenTestimonials;
            const hiddenTitle = payload.hiddenTitle;
            const item = state.uploads.items[index];
            if (index == state.uploads.items.length) {
                dispatch("stopUploads");
            } else {
                if (item.isUsed) {
                    if (state.uploads.started) {
                        item.isWaiting = true;

                        rootState.love.testimonials
                            .filter((x) => x.id !== item.id)
                            .forEach((y) => (y.hide = true));

                        rootState.love.wall.hideTitle = true;

                        dispatch("love/refreshIframe", null, { root: true });
                        setTimeout(() => {
                            dispatch("callForImage", {
                                wallImage: false,
                                index,
                                recursive: true,
                                hiddenTestimonials,
                            });
                        }, 300);
                    }
                } else {
                    dispatch("uploadItem", { index: index + 1, hiddenTestimonials, hiddenTitle });
                }
            }
        },
        generateImages({ state, rootState, commit, dispatch }) {
            if (!rootState.love.testimonials.length) {
                dispatch("showNoTestimonialsModal");
                return;
            }

            if (!state.uploads.finished) {
                state.uploads.items = [];
                rootState.love.testimonials
                    .filter((x) => !x.hide)
                    .forEach((x) => {
                        state.uploads.items.push({
                            ...x,
                            isUsed: true,
                            isDone: false,
                            isWaiting: false,
                            link: "",
                        });
                    });
            }

            const modalData = {
                type: "upload",
                callback: () => {
                    state.imageWidth = "1080px";
                    rootState.love.wall.layout = "board";
                    dispatch("startUploads");
                },
                stopCallback: () => {
                    dispatch("stopUploads");
                },
            };
            commit("showModal", modalData, { root: true });
        },
        generateImage({ state, rootState, dispatch }, payload) {
            const testimonialId = payload ? payload : undefined;

            if (!rootState.love.testimonials.length) {
                dispatch("showNoTestimonialsModal");
                return;
            }

            state.imageWidth = "1080px";
            const hiddenTestimonials = rootState.love.testimonials
                .filter((x) => x.hide)
                .map((y) => y.id);
            if (testimonialId) {
                rootState.love.testimonials
                    .filter((x) => x.id !== testimonialId)
                    // This will MUTATE every testimonial !!!!
                    .forEach((y) => (y.hide = true));
            }
            rootState.love.wall.layout = "board";
            dispatch("love/refreshIframe", null, { root: true });
            setTimeout(() => {
                dispatch("callForImage", {
                    wallImage: !testimonialId,
                    recursive: false,
                    hiddenTestimonials: hiddenTestimonials,
                });
            }, 300);
        },
        async generateImage2({ rootState, getters, dispatch }, testimonial) {
            const singleTestimonialMode = !!testimonial;

            rootState.waiting = true;
            const wall = cloneDeep(rootState.love.wall);
            if (singleTestimonialMode) {
                wall.testimonials = [cloneDeep(testimonial)];
                wall.hideTitle = true;
            }
            wall.layout = "board";
            wall.showFooter = false;
            wall.showCreateLink = false;

            const iframe = rootState.love.iframe;
            if (iframe && wall.id) {
                iframe.contentWindow.postMessage({ wallData: wall }, getters.appUrl);
            }
            await waitForMe(200);

            setTimeout(() => {
                dispatch("callForImage2", {
                    wallImage: !singleTestimonialMode,
                    recursive: false,
                });
            }, 300);
        },
        async callForImage({ state, rootState, dispatch }, payload) {
            const { index, hiddenTestimonials, hiddenTitle, recursive, wallImage } = payload;

            const link = document.createElement("link");
            link.setAttribute("rel", "stylesheet");
            link.setAttribute("as", "style");
            link.setAttribute("href", "https://app.easy.tools/front/css/style.css");
            rootState.love.iframe.contentDocument.head.appendChild(link);

            const link2 = document.createElement("link");
            link2.setAttribute("rel", "stylesheet");
            link2.setAttribute("as", "style");
            link2.setAttribute("href", "https://app.easy.tools/love/css/style.css");
            rootState.love.iframe.contentDocument.head.appendChild(link2);

            try {
                const { url } = await bannerService.makeCreation(
                    rootState.love.iframe.contentDocument,
                    wallImage
                );
                rootState.love.testimonials.forEach((y) => {
                    if (hiddenTestimonials.indexOf(y.id) === -1) {
                        y.hide = false;
                    }
                });
                rootState.love.wall.hideTitle = hiddenTitle;
                if (!recursive) {
                    state.imageWidth = "";
                    dispatch("showDownloadImageModal", url);
                    dispatch("love/refreshIframe", null, { root: true });
                } else {
                    const item = state.uploads.items[index];
                    item.isDone = true;
                    item.link = url;
                    dispatch("uploadItem", { index: index + 1, hiddenTestimonials });
                }
                rootState.waiting = false;
            } catch {
                /* eslint-disable-next-line no-empty */
            }
        },
        async callForImage2({ state, rootState, dispatch }, payload) {
            const { index, recursive, wallImage } = payload;

            const link = document.createElement("link");
            link.setAttribute("rel", "stylesheet");
            link.setAttribute("as", "style");
            link.setAttribute("href", "https://app.easy.tools/front/css/style.css");
            rootState.love.iframe.contentDocument.head.appendChild(link);

            const link2 = document.createElement("link");
            link2.setAttribute("rel", "stylesheet");
            link2.setAttribute("as", "style");
            link2.setAttribute("href", "https://app.easy.tools/love/css/style.css");
            rootState.love.iframe.contentDocument.head.appendChild(link2);

            try {
                const { url } = await bannerService.makeCreation(
                    rootState.love.iframe.contentDocument,
                    wallImage
                );

                if (!recursive) {
                    state.imageWidth = "";
                    dispatch("showDownloadImageModal", url);
                    dispatch("love/refreshIframe", null, { root: true });
                } else {
                    const item = state.uploads.items[index];
                    item.isDone = true;
                    item.link = url;
                    dispatch("uploadItem", { index: index + 1 });
                }
                rootState.waiting = false;
            } catch {
                // Bring back the whole wall view:
                dispatch("love/refreshIframe", null, { root: true });
            }
        },
    },
};
